import { AnswerType } from '@webapp/common/resources/survey';

import { calcAndSetAnsweredCount } from '@webapp/survey/src/api/types/common/utils';
import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { ResponseEventParams } from '../../entities/response-machine';
import { excludeHiddenAnswers } from '../../machine/helpers/logic';
import type { AnswersRequest } from '../queries-api';

import { ListApi } from './common/list';

export class FewOfListApi extends ListApi {
    public change(q: QuestionContext, evt: ResponseEventParams): void {
        const { answerId, value } = evt;
        const { answersActors, responseActor, id } = q;
        responseActor.send({ type: 'CHANGE', value, questionId: id });

        answersActors.forEach((aRaw) => {
            const a = aRaw.getSnapshot().context;
            if (a.response.getSnapshot().context.value && !a.valid) {
                // FIXME
                a.valid = true;
            }
        });

        calcAndSetAnsweredCount(q);

        answersActors.forEach((otherAnswerRaw) => {
            const otherAnswer = otherAnswerRaw.getSnapshot().context;
            const answer = answersActors.find((a) => {
                return a.getSnapshot().context.id === answerId;
            });
            if (
                (answer.getSnapshot().context.exception || otherAnswer.exception) &&
                answer.getSnapshot().context.id !== otherAnswer.id
            ) {
                otherAnswer.response?.send({ type: 'SET', value: false });

                if (otherAnswer.response.getSnapshot().context.extra) {
                    otherAnswer.response?.send({ type: 'SET_EXTRA', value: '' });
                }
            }
        });
    }

    public query(actor: QuestionActor): AnswersRequest {
        const { id, answersActors: answersActorsRaw, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        const answersActors = excludeHiddenAnswers(answersActorsRaw);
        return {
            question: id,
            data: answersActors.map((answersActor) => {
                const { id, response: responseActor } = answersActor.getSnapshot().context;
                const response = responseActor.getSnapshot().context;
                const value = !!response.value;
                return {
                    answer: id,
                    bool: value || false,
                    longtext: value && response.extra !== null ? String(response.extra) : undefined,
                };
            }),
            comment,
        };
    }

    public validate(q: QuestionContext): boolean {
        const question = q;
        const {
            answersActors: answersActorsRaw,
            params: { maxLength, minLength, required },
        } = question;

        if (!required) return true;

        const haveMaxLength = typeof maxLength === 'number';
        const haveMinLength = typeof minLength === 'number';
        let answeredCount = 0;
        let haveException = false;
        let valid = true;
        const answersActors = excludeHiddenAnswers(answersActorsRaw);

        const isAnyEmptySelfAnswer = answersActors
            .filter((aRaw) => {
                const a = aRaw.getSnapshot().context;
                return a.type === AnswerType.SELF;
            })
            .some((a) => {
                const response = a.getSnapshot().context.response.getSnapshot().context;
                return response.value && !response.extra;
            });
        if (isAnyEmptySelfAnswer) return false;
        answersActors.forEach((aRaw) => {
            const a = aRaw.getSnapshot().context;
            const { exception, response: responseActor, type } = a;
            if (!responseActor) return;
            const response = responseActor.getSnapshot().context;

            const value = !!response.value;

            const valid = type === AnswerType.SELF ? !!response.extra && value : value;

            if (valid) {
                ++answeredCount;
            }

            if (exception && value) {
                haveException = true;
            }

            // a.valid = valid;
        });

        if (haveException) return true;

        if (required) {
            valid = answeredCount > 0;
        }

        if (haveMinLength) {
            valid = valid && answeredCount >= minLength;
        }

        if (haveMaxLength) {
            valid = valid && answeredCount <= maxLength;
        }

        return valid;
    }
}
